/**
 * 用於清理字串中的不可見字符和標準化 URL
 */

/**
 * 正則表達式匹配各種不可見字符：
 * - \p{Cf}: Unicode 格式控制字符，包括：
 *   - 200B: 零寬空格 (Zero Width Space)
 *   - 200C: 零寬非連接符 (Zero Width Non-Joiner)
 *   - 200D: 零寬連接符 (Zero Width Joiner)
 *   - 2060: 單詞連接符 (Word Joiner)
 *   - FEFF: 零寬非斷空格，也稱為位元順序標記 (BOM)
 * - \u00A0: 不間斷空格 (Non-Breaking Space)
 *
 * 這些字符通常肉眼不可見，但可能會導致 URL 失效或比較不一致
 */
const INVISIBLES = /[\p{Cf}\u00A0]/gu // Cf 含 200B/200C/200D/2060/FEFF；

export const clean = (s) =>
  typeof s === 'string' ? s.normalize('NFC').replace(INVISIBLES, '').trim() : s
